var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNightHeroBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 609,
    viewBox: "0 0 1200 609",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_17466)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 609,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_89_17466)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_89_17466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747.406 348.597C337.938 605.661 38 405.234 -119.311 336.084L-17.349 699.749C132.837 794.377 694.959 708.594 951.526 381.143C1156.78 119.183 1363.9 89.1962 1441.8 106.948L1387.59 -86.4092C1131.07 -68.3545 1156.87 91.5322 747.406 348.597Z",
    fill: "url(#paint0_linear_89_17466)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_89_17466",
    x: -219.311,
    y: -186.409,
    width: 1761.11,
    height: 1022.35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_89_17466"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_17466",
    x1: 134.843,
    y1: 300.538,
    x2: 434.191,
    y2: 909.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770593,
    stopColor: "#AA1200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959012,
    stopColor: "#C72600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_17466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 609,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_89_17466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1644,
    height: 814,
    fill: "white",
    transform: "translate(-122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightHeroBanner);
export default __webpack_public_path__ + "static/media/NightHeroBanner.1e9544b112258f0e4fe2f84bd9320527.svg";
export { ForwardRef as ReactComponent };